import React from "react";
import { I } from "../../ui/icons";
import { ENV_LABEL, ENV_ORDER, consoleEnvOf, productState } from "./model";

function EnvStatus({ env, connectedEnv, products }) {
  if (env !== connectedEnv) return <span className="chip unk"><I.minus s={11} />Not visible here</span>;
  const active = products.filter((p) => productState(p) === "active").length;
  if (active === products.length) return <span className="chip ok"><I.check s={11} />All active</span>;
  return <span className={`chip ${env === "production" ? "warn" : "muted"}`}>{env === "production" ? <I.alert s={11} /> : <I.minus s={11} />}{active} of {products.length} active</span>;
}

/** On Review and publish: where the course's AHA products stand, so a publisher sees what is not yet activated. */
export default function ReadyToGoLive({ products, versionNumber, setTab }) {
  if (!products) return null;
  const connectedEnv = consoleEnvOf(products[0]?.environment);
  return (
    <div className="rgl" data-testid="ready-to-go-live">
      <div className="rgl-h">
        <b>Ready to go live</b>
        <button type="button" className="b ghost sm" onClick={() => setTab("integrations")}>Open Integrations<I.chev s={12} /></button>
      </div>
      {products.length === 0 ? (
        <p className="sub" style={{ margin: 0, fontSize: 13 }}>No integrations linked. Classes will issue the platform certificate only.</p>
      ) : (
        <div style={{ display: "grid", gap: 8 }}>
          <div style={{ fontWeight: 600, fontSize: 13.5 }}>AHA eCards<span className="sub" style={{ fontWeight: 400 }}> · {products.length} product{products.length > 1 ? "s" : ""}</span></div>
          <div className="rgl-g">
            {ENV_ORDER.map((env) => (
              <div key={env}><span className="eyebrow">{ENV_LABEL[env]}</span><EnvStatus env={env} connectedEnv={connectedEnv} products={products} /></div>
            ))}
          </div>
        </div>
      )}
      <p className="rgl-f">Publishing v{versionNumber} does not activate anything. After publishing, activate each environment on the Integrations tab.</p>
    </div>
  );
}
